import React from 'react'
import './Aside.css'
import { useState,useEffect } from 'react';
import burgerIcon from '../img/burger-gy-icon.svg'
import closeIcon from '../img/close-gy-icon.svg'


function Aside({change }){
    const [site, setSite] = useState("nitro");
    const changeSite=(e)=>{
        setSite(e)
    }

    const[burger,setBurger] = useState(false);
    const changeBurger=(e)=>{
        e===null?setBurger(e):setBurger(!burger)
    }

    useEffect(() => {
        if(burger===true){
             const timer = setTimeout(() => {
            changeBurger(false)
        }
            , 500);
        return () => clearTimeout(timer);
        }
       
      }, [site]);

    
    return(
        <>
        <div className="aside">
                <ul>
                    <li><a  className={site=="nitro"?"active":""} onClick={() => { change("nitro"); changeSite('nitro')}}
                        data-nick="nitro"><span className="sub">Nitro</span></a></li>
                    {/*<li><a   className={site=="level"?"active":""} data-nick="level" onClick={() =>{ change("level");; changeSite('level')}}><span className="sub">Nivel</span></a></li>
                    */}
                    <li><a   data-nick="setup"><span className="sub">Setup</span></a></li>
                    
                </ul>
        </div>
        <div className='burger' onClick={changeBurger}>
            <img src={burger?closeIcon:burgerIcon}/>
        </div>
        <div className="aside-min" style={burger?{display:'block'}:{display:'none'}}>
                <ul>
                    <li><a  className={site=="nitro"?"active":""} onClick={() => { change("nitro"); changeSite('nitro')}}
                        data-nick="nitro"><span className="sub">Nitro</span></a></li>
                    {/*<li><a   className={site=="level"?"active":""} data-nick="level" onClick={() =>{ change("level");; changeSite('level')}}><span className="sub">Nivel</span></a></li>
                    */}
                    
                    <li><a   data-nick="setup"><span className="sub">Setup</span></a></li>
                </ul>
        </div>
        </>
    )
}

export default Aside